<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">Pending For Approval</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">EmailId</th>
                      <th scope="col">Description</th>
                      <th scope="col">Mobile</th>
                      <th scope="col">latestStatus</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let customer of customerData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                      }  ;let i = index">
                      <th scope="col">{{customer.name}}</th>
                      <th scope="col">{{customer.emailId}}</th>
                      <th scope="col">{{customer.description}}</th>
                      <th scope="col">{{customer.mobileNo1}}</th>
                      <th scope="col">{{customer.latestStatus}}</th>
                      <th scope="col">
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getCustomerInfoById(customer.customerInfoId)" data-toggle="modal" data-target="#exampleModalView"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
                    </th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="customerData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->
  
            <div class="personal-details">
          
                <div class="header-block">
                    <div class="header-title">
                        <p>Pending For Approval</p>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" placeholder="search">
                            </form>
                            <i class="bi bi-search" ></i>
                        </div>
                    </div>
                </div>
  
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 20%;">EmailId</th>
                        <th style="width: 20%;">Description</th>
                        <th style="width: 15%;">Mobile</th>
                        <th style="width: 15%;">latestStatus</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let customer of customerData | paginate : {
                        itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                        }  ;let i = index">
  
                        <p style="width: 20%;">{{customer.name}}</p>
                        <p style="width: 20%;">{{customer.emailId}}</p>
                        <p style="width: 20%;">{{customer.description}}</p>
                        <p style="width: 15%;">{{customer.mobileNo1}}</p>
                        <p style="width: 15%;">{{customer.latestStatus}}</p>                     
                        <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                            <i *ngIf="actionControls.isView" (click)="getCustomerInfoById(customer.customerInfoId)" data-toggle="modal" data-target="#exampleModalView" class="bi bi-eye-fill"></i>
                        </p>
                    </div>
                </div>
  
  
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
  
                <div class="loader"  *ngIf="!isLoading && customerData.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
  
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>
  
  
            </div>

        </div>
    </div>
</div>



<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Customer Details
                <span data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </span>
            </h5>
        </div>
        <div class="modal-body" *ngFor="let customer of singleCustomerInfo">
    
          <div>
              <div class="row view" >
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{customer.name}}" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Email</label>
                          <input type="email" value="{{customer.emailId}}" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Mobile No1</label>
                          <input type="text" value="{{customer.mobileNo1}}" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Mobile No2</label>
                          <input type="text" value="{{customer.mobileNo2}}" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{customer.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Address</label>
                          <textarea class="form-control" value="{{customer.address}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                  <div class="col-md-6 col-lg-6" *ngIf="customer.image != null && customer.image != '' && customer.image != undefined && customer.image != 'string'">
                        <div class="form-group">
                            <label>Image:</label>
                            <div>
                                <img src="{{customer.image}}" width="100px" height="100px" alt="">
                            </div>
                        </div>
                  </div>
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group" style="text-align: center;">
                          <label >Params</label>
                      </div>
                  </div>
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngFor="let params of customer.customerParamEntityList">
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.key}}" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.value}}" class="form-control">
                        </div>
                    </div>
                  </div>
              </div>
           
    
          </div>
    
     
        <div class="modal-footer">
          <button type="button" *ngIf="customer.latestStatus != 'REJECTED' && customer.latestStatus != 'APPROVED' && buttonDisable == false" class="btn btn-danger left" (click)="rejectCustomerInfo()" >Reject</button>
          <button type="button" id="closeModalButton4"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" *ngIf="customer.latestStatus != 'APPROVED' && customer.latestStatus != 'REJECTED' && buttonDisable == false"  class="btn btn-primary" (click)="approveCustomerInfo()" >Approve</button>
        </div>
      </div>
    </div>
    </div>
</div>
